<template>
  <b-alert
    variant="warning"
    show
    class="m-2 text-center"
  >

    <div class="alert-body">
      <div><feather-icon icon="InfoIcon" /></div>
      Paketiniz bu alanı desteklemiyor.
      <div>
        <small>Bu alanı kullanabilmeniz için üst paketlere geçebilirsiniz.</small>
      </div>
    </div>
  </b-alert>
</template>
<script>
import { BAlert } from 'bootstrap-vue'

export default {
  name: 'LimitReachedCard',
  components: { BAlert },
}
</script>
